<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<router-outlet></router-outlet>
<!-- <div *ngIf="message">
  <h1>{{ message.notification.title }}</h1>
  <h2>{{ message.notification.body }}</h2>
</div>

<div *ngIf="!message" style="color: #f3f4f9">No Message Arrived</div> -->
